export enum FiatBankAccountStatusEnum {
  Created = 'submitted',
  Activated = 'completed',
  Pending = 'pending',
  Rejected = 'rejected',
  Escalated = 'escalated',
  Expired = 'expired',
}

export type FiatBankAccountStatus = `${FiatBankAccountStatusEnum}`;

export enum BankAccountDisplayStatusEnum {
  Verified = 'Verified',
  Pending = 'Pending',
  Failed = 'Failed',
  Rejected = 'Rejected',
  Expired = 'Expired',
}

export type BankAccountDisplayStatus = `${BankAccountDisplayStatusEnum}`;

export interface FiatBankAccountItem {
  label: string;
  bankName: string;
  bankNumber: string;
  paymentNetwork: string;
  paymentNetworkDisplayName: string;
  supportedPaymentNetworks: string[];
  currency: string;
  id: string;
  createdAt: string;
  createdAtDisplay: string;
  status: FiatBankAccountStatus;
  statusDisplay: BankAccountDisplayStatus;
  bankDetails: any;
  _raw?: any;
}

export interface FiatBankAccountsResponse {
  fiatBankAccounts: FiatBankAccountItem[];
  validBankAccounts: FiatBankAccountItem[];
}

export interface IntermediaryBankSelectOption {
  bank_identifier_type?: string;
  bank_identifier_value?: string;
  bank_name?: string;
  address_1?: string;
  address_2?: string;
  address_3?: string;
  type?: string;
}

export type IntermediaryBankSelectOptions = IntermediaryBankSelectOption[];
